import { render } from "./office-info.vue?vue&type=template&id=743d880c&scoped=true&ts=true"
import script from "./office-info.vue?vue&type=script&lang=ts"
export * from "./office-info.vue?vue&type=script&lang=ts"

import "./office-info.vue?vue&type=style&index=0&id=743d880c&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-743d880c"]])

export default __exports__